import "./index.scss";

const TitleLine = ({ title }: { title: string }) => {
  return (
    <div className="title-line">
      <div className="title-line-text">{title}</div>
    </div>
  );
};

export default TitleLine;
